import React from "react";

const extractCityFromText = (value) => {
  const text = String(value || "").trim();
  if (!text) return "";

  const parts = text
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);

  return parts.length > 1 ? parts[parts.length - 1] : text;
};

const labelStyle = {
  fontSize: "13px",
  fontWeight: "normal",
  color: "#000",
  whiteSpace: "nowrap",
  display: "inline-block",
};

const separatorStyle = {
  fontSize: "13px",
  fontWeight: "normal",
  color: "#000",
  marginRight: "6px",
};

const valueStyle = {
  fontSize: "13px",
  fontWeight: "bold",
  color: "#000",
};

const rowStyle = { height: "20px" };

const LedgerMasterDetails = ({ ledger = {}, showDetailsLabel = "" }) => {
  const data = ledger || {};

  return (
    <div className="row">
      <div className="col-4">
        <div className="d-flex align-items-center" style={rowStyle}>
          <span style={{ ...labelStyle, width: "70px" }}>Ledger</span>
          <span style={separatorStyle}>:</span>
          <span className="text-truncate" style={valueStyle}>
            {data?.ledger_name}
          </span>
        </div>
        {showDetailsLabel ? (
          <div className="d-flex align-items-center" style={rowStyle}>
            <span style={{ ...labelStyle, width: "70px" }}>Details</span>
            <span style={separatorStyle}>:</span>
            <span className="text-truncate" style={valueStyle}>
              {showDetailsLabel}
            </span>
          </div>
        ) : null}
        <div className="d-flex align-items-center" style={rowStyle}>
          <span style={{ ...labelStyle, width: "70px" }}>City</span>
          <span style={separatorStyle}>:</span>
          <span className="text-truncate" style={valueStyle}>
            {data?.city || extractCityFromText(data?.ledger_name)}
          </span>
        </div>
      </div>

      <div className="col-4 p-0">
        <div className="d-flex align-items-center" style={rowStyle}>
          <span style={{ ...labelStyle, width: "70px" }}>Ac No</span>
          <span style={separatorStyle}>:</span>
          <span className="text-truncate" style={valueStyle}>
            {data?.account_no}
          </span>
        </div>
        <div className="d-flex align-items-center" style={rowStyle}>
          <span style={{ ...labelStyle, width: "70px" }}>Mobile</span>
          <span style={separatorStyle}>:</span>
          <span className="text-truncate" style={valueStyle}>
            {data?.mobile_no}
          </span>
        </div>
      </div>

      <div className="col-4 p-0">
        <div className="d-flex align-items-center" style={rowStyle}>
          <span style={{ ...labelStyle, width: "135px" }}>Aadhar Number</span>
          <span style={separatorStyle}>:</span>
          <span className="text-truncate" style={valueStyle}>
            {data?.aadhaar}
          </span>
        </div>
        <div className="d-flex align-items-center" style={rowStyle}>
          <span style={{ ...labelStyle, width: "135px" }}>
            Transport Details
          </span>
          <span style={separatorStyle}>:</span>
          <span className="text-truncate" style={valueStyle}>
            {data?.transport_detail}
          </span>
        </div>
      </div>
    </div>
  );
};

export default LedgerMasterDetails;
